module.exports = __webpack_public_path__ + "img/mir.e09af155.svg";